import * as React from 'react';
import { Label } from 'task-manager/TaskFilters.styles';
import { handleUndefinedFilter } from './utils';
import { InboxType } from 'task-manager/types';
import { formatScreamingSnakesToPrettyStrings } from 'task-manager/formatScreamingSnakesToPrettyStrings';
import { ArrayParam, useQueryParam } from 'use-query-params';

type InboxTypeFilterProps = {
  handleSelectChange: (value: string | string[], name: string) => void;
};

export const InboxTypeFilter = ({ handleSelectChange }: InboxTypeFilterProps) => {
  const [inboxTypes] = useQueryParam('inboxTypes', ArrayParam);
  return (
    <span key={'inboxTypeFilter'}>
      <Label>Inbox Type</Label>
      <select
        aria-label="inboxTypes dropdown"
        name="inboxTypes"
        value={handleUndefinedFilter(inboxTypes)}
        onChange={event =>
          handleSelectChange(
            InboxType[event.target.value] ? [event.target.value] : event.target.value,
            event.target.name,
          )
        }
      >
        <option value={undefined}>All</option>
        {Object.values(InboxType).map(type => (
          <option value={type} key={type}>
            {formatScreamingSnakesToPrettyStrings(type)}
          </option>
        ))}
      </select>
    </span>
  );
};
